import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHand = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 13V12C20 11.4696 19.7893 10.9609 19.4142 10.5858C19.0391 10.2107 18.5304 10 18 10C17.4696 10 16.9609 10.2107 16.5858 10.5858C16.2107 10.9609 16 11.4696 16 12V21.523C15.9999 21.6863 15.9598 21.8471 15.8832 21.9914C15.8066 22.1357 15.6958 22.2589 15.5605 22.3505C15.4253 22.442 15.2697 22.4991 15.1073 22.5166C14.9449 22.5341 14.7807 22.5116 14.629 22.451L12.086 21.434C11.7637 21.305 11.4106 21.2735 11.0705 21.3434C10.7304 21.4132 10.4184 21.5814 10.173 21.827V21.827C9.85466 22.1451 9.66917 22.5723 9.65413 23.022C9.63909 23.4717 9.79562 23.9104 10.092 24.249L13.31 27.927C14.1549 28.8924 15.1964 29.6661 16.3647 30.1961C17.533 30.7261 18.8011 31.0002 20.084 31H22C24.3869 31 26.6761 30.0518 28.364 28.364C30.0518 26.6761 31 24.3869 31 22V13.5C31 13.1022 30.842 12.7206 30.5607 12.4393C30.2794 12.158 29.8978 12 29.5 12C29.1022 12 28.7206 12.158 28.4393 12.4393C28.158 12.7206 28 13.1022 28 13.5V14",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 19V11C20 10.4696 20.2107 9.96086 20.5858 9.58579C20.9609 9.21071 21.4696 9 22 9C22.5304 9 23.0391 9.21071 23.4142 9.58579C23.7893 9.96086 24 10.4696 24 11V19",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 13V12C24 11.4696 24.2107 10.9609 24.5858 10.5858C24.9609 10.2107 25.4696 10 26 10V10C26.5304 10 27.0391 10.2107 27.4142 10.5858C27.7893 10.9609 28 11.4696 28 12V19",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgHand);
export default ForwardRef;
